import React from "react";
import { Helmet } from "react-helmet-async";
const SchemaComponent = () => {
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "Am I suitable?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Anyone who has lost a tooth or several teeth is a candidate for dental implants.As long as a full assessment is completed and treatment is planned properly and tailored to suit the individual’s specific requirements, then dental implants can usually be placed. Patients are assessed on an individual basis; every patient will have a thorough consultation using a combination of radiographic and diagnostic techniques, with an in depth analysis of their lifestyle and objectives.",
        },
      },
      {
        "@type": "Question",
        name: "I have gum disease, can I have implants?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Yes, periodontal patients can have dental implants. However, it is important the gum disease affecting your remaining natural teeth is adequately treated before implant placement. It is also important to note that the risk of complications related to implant treatment seems to be somewhat higher in periodontal patients, but with regular maintenance, it is not a contraindication.",
        },
      },
      {
        "@type": "Question",
        name: "Will you have to remove or treat diseased teeth prior to treatment?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Despite advances in modern dentistry some teeth may have reached a stage where no treatment can save them. It is often best to remove them at an early stage, particularly if you are thinking of having implants so as to prevent further bone loss. We would need to treat or remove all pre-existing oral infection wherever possible.",
        },
      },
      {
        "@type": "Question",
        name: "How long do implants last?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Implants have high success rates and there are reports that have assessed their performance over a period of more than 25 years. The most recent studies indicate that 90% of implants placed ten years ago are still functional today. The long-term success of implants also depends greatly on how well they are cleaned and maintained. In most cases, as a minimum, an annual check-up and regular hygienist visits are recommended so the implants can be professionally cleaned. Moreover, brushing and flossing at home is of paramount importance.",
        },
      },
      {
        "@type": "Question",
        name: "What is a sinus graft?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "It is very common to find that the softer bone in the area above the upper back teeth is very shallow and not suitable for normal implant procedures. To solve this problem a procedure known as a “sinus augmentation” or “sinus lift” was developed. Bone may be successfully grown in the sinus spaces above your upper back teeth allowing implants to be placed.",
        },
      },
      {
        "@type": "Question",
        name: "I’m a really nervous patient, what are my options?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Is dental fear and phobia preventing you from having your perfect smile with dental implants? We understand that a visit to the dentist can be quite challenging. We believe everybody deserves a smile that is healthy and happy and we are committed to working with you to help get treatment. That’s why we have adopted a relaxed and informal approach that helps put our patients at ease. Moreover, we offer dental sedation to ensure you never skip your next dental appointment again. Dr Nadeem Sabir provides patients treatment with Intravenous Sedation, which involves the controlled delivery of a sedative drug, which quickly induces feelings of deep relaxation and peace. Further, this leaves you with little or no recollection of the procedure. Intravenous sedation is not like a general anaesthetic, in that you do not lose consciousness. We have been able to help many patients finally overcome dental anxiety by providing them the dental treatment they need using a relaxed and calming approach.",
        },
      },
      {
        "@type": "Question",
        name: "Can dental implants be done in a single day?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Yes, dental implants can sometimes be done in a single day, a procedure known as “same-day dental implants” or “teeth in a day.” This approach allows for the placement of the implant and a temporary crown or bridge in a single visit. However, not all patients are suitable candidates for this procedure.Some Factors That Determine Eligibility:Bone Density & Health – Adequate bone structure is needed to support the implant.Oral Health – Healthy gums and no active infections or gum disease are essential.Overall Health – Conditions like diabetes or smoking habits may affect healing.What is the difference between full arch implants and traditional dentures?The main difference between full arch implants and traditional dentures is how they are supported and secured in the mouth. Full mouth implants are anchored to the jawbone using 4-6 dental implants usually. They are very secure and do no not slip or move like dentures. Full arch implants feel more like natural teeth and there is no need for adhesives unlike dentures. Further, implants help preserve jawbone by preventing bone loss whereas dentures do not do this, which can lead to changes in facial structure. Full arch implants are the better option for long-term oral health, comfort and function.",
        },
      },
      {
        "@type": "Question",
        name: "What is the average lifespan of dental implants?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Implants have high success rates and there are reports that have assessed their performance over a period of more than 25 years. The most recent studies indicate that 90% of implants placed ten years ago are still functional today. The long-term success of implants also depends greatly on how well they are cleaned and maintained. In most cases, as a minimum, an annual check-up and regular hygienist visits are recommended so the implants can be professionally cleaned. Moreover, brushing and flossing at home is of paramount importance.",
        },
      },
      {
        "@type": "Question",
        name: "How should I maintain and clean my full arch implants?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Cleaning full arch implants is crucial to maintaining oral health and preventing complications like gum disease around implants. Caring for implants includes brushing twice a day, flossing, using an antibacterial mouthwash, and regular dental check-ups. We also recommend specific tools, like a water flosser, to clean around the implants. An annual check-up and regular hygienist visits are recommended so the implants can be professionally cleaned.",
        },
      },
      {
        "@type": "Question",
        name: "Will I experience pain during or after the implant procedure?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "During the dental implant procedure, you shouldn’t feel any pain because wea will use a local anaesthetic to numb the area. You may feel some pressure or mild discomfort, but it shouldn’t be painful. We also provide intravenous sedation for patients who are anxious.After the procedure, it’s normal to experience some soreness, swelling, and mild discomfort for a few days. This is usually manageable with over-the-counter pain relievers like ibuprofen or paracetamol. Most people find the discomfort improves significantly within a 24-48 hours.",
        },
      },
      {
        "@type": "Question",
        name: "How soon can I eat normally after getting implants?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "You can typically eat a few hours after your dental implant procedure. However, you should stick to soft foods and liquidsfor at least the first 24 to 48 hours to avoid disturbing the surgical site and avoid anything to hot.",
        },
      },
      {
        "@type": "Question",
        name: "Will my speech be affected by full arch implants?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Full arch implants can affect your speech, especially in the initial adjustment period. However, most people adapt quickly, and speech typically improves over time. Most patients find that their speech returns to normal or even improves as they get used to their implants.",
        },
      },
    ],
  };
  const schemaData2 = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "@id": "https://www.dentalimplants-ilkley.com/#organization",
    headline:
      "Dental Implants and Replace Missing Teeth in Ilkley West Yorkshire",
    url: "https://www.dentalimplants-ilkley.com/",
    name: "Dental Implants ilkley",
    description:
      "Local Dentist in Kington Herefordshire - “ this part of it will be replaced with “Local Dentist in Ilkley, West Yorkshire",
    inLanguage: "en-UK",
    author: { "@id": "https://www.dentalimplants-ilkley.com/#organization" },
    creator: { "@id": "https://www.dentalimplants-ilkley.com/#organization" },
    publisher: { "@id": "https://www.dentalimplants-ilkley.com/#organization" },
    provider: { "@id": "https://www.dentalimplants-ilkley.com/#organization" },
    mentions: [
      "https://en.wikipedia.org/wiki/Dental_implant",
      "Dental implants",
    ],
  };
  const schemaData3 = {
    "@context": "https://schema.org/",
    "@type": "LocalBusiness",
    name: "Dental Implants ilkley",
    url: "https://www.dentalimplants-ilkley.com/",
    sameAs: ["https://www.instagram.com/regentdental_ilkley/"],
    address: {
      "@type": "PostalAddress",
      streetAddress: "2A Regent Rd",
      addressLocality: "Ilkley",
      postalCode: "LS29 9EA",
      addressCountry: "UK",
    },
    telephone: "+44 1943 661331",
    openingHours: "Mo-saturday 09:00-17:00",
    image:
      "https://www.dentalimplants-ilkley.com/static/media/header-logo.d5abac7d7e76717023d1.png",
  };
  // const schemaData4 = {
  //   "@context": "https://schema.org/",
  //   "@type": "Product",
  //   name: "Dental Implants",
  //   image: "",
  //   description:
  //     "Dental implants are artificial titanium tooth roots that are surgically inserted into the jawbone. They provide a strong foundation for fixed or removable replacement teeth, such as crowns, bridges, or dentures, that are designed to match your natural teeth in appearance and function.",
  // }
  const schemaData5 = {
    "@context": "https://schema.org",
    "@type": "Service",
    name: "Dental Implants",
    description:
      "Restore your smile with dental implants in Ilkley. We provide long-lasting, natural-looking solutions tailored to your needs. Book a consultation today.",
    provider: {
      "@type": "LocalBusiness",
      name: "Dental Implants Ilkley",
      image:
        "https://www.dentalimplants-ilkley.com/static/media/header-logo.d5abac7d7e76717023d1.png",
      telephone: "+44 1943 661331",
      email: "info@example.com",
      address: {
        "@type": "PostalAddress",
        streetAddress: "2A Regent Rd",
        addressLocality: "Ilkley",
        addressRegion: "West Yorkshire",
        postalCode: "LS29 9EA",
        addressCountry: "GB",
      },
      url: "https://www.dentalimplants-ilkley.com/",
    },
    areaServed: {
      "@type": "Place",
      name: "Ilkley, GB",
    },
    serviceType: "Dental Implant",
    url: "https://www.dentalimplants-ilkley.com/",
  };
  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schemaData)}</script>
      <script type="application/ld+json">{JSON.stringify(schemaData2)}</script>
      <script type="application/ld+json">{JSON.stringify(schemaData3)}</script>
      <script type="application/ld+json">{JSON.stringify(schemaData5)}</script>
      {/* <script type="application/ld+json">{JSON.stringify(schemaData4)}</script> */}
    </Helmet>
  );
};

export default SchemaComponent;
